<div class="dr-footer">
  <button id="footer.btn.switch_locale"
          mat-menu-item
          class="button-language"
          (click)="updateLocale(locale === smp360Locales.DE ? smp360Locales.EN : smp360Locales.DE)">
    <span class="span-language">{{(locale === smp360Locales.DE ? 'EN' : 'DE')}}</span>
  </button>
</div>
